import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Response } from '../../../../../app/common/Response';
import { EmopUtilsService } from '../../../../../app/services/emop-utils.service';
import { HttpClient } from '@angular/common/http';
import { NzModalRef } from 'ng-zorro-antd/modal';
@Component({
  selector: 'app-emop-sidebar-password',
  templateUrl: './emop-sidebar-password.component.html',
  styleUrls: ['./emop-sidebar-password.component.scss']
})
export class EmopSidebarPasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  @Input() userInfo; // 用户信息
  constructor(
    private fb: FormBuilder,
    private emop: EmopUtilsService,
    private http: HttpClient,
    private NzModalRef: NzModalRef
  ) { }

  ngOnInit(): void {
    this.changePasswordForm = this.fb.group({
      oldPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required]],
      newPassword1: [null, [Validators.required]],
    });
  }
  /**
   * 修改密码弹窗的取消事件
   */
  changePasswordModalCancel() {
    this.NzModalRef.close();
  }
  /**
   * 修改密码弹窗的确认事件
   */
  changePasswordModalOk() {
    for (const key in this.changePasswordForm.controls) {
      this.changePasswordForm.controls[key].markAsDirty();
      this.changePasswordForm.controls[key].updateValueAndValidity();
    }
    if (this.changePasswordForm.valid) {
      if (this.changePasswordForm.value.newPassword !== this.changePasswordForm.value.newPassword1) {
        this.emop.message('info', '两次新密码输入不一致');
      } else {
        this.http.get<Response<any>>('/usercenter/update-password', {
          params: {
            userId: this.userInfo?.additionalData?.additionalData.id,
            oldPassword: this.changePasswordForm.value.oldPassword,
            newPassword: this.changePasswordForm.value.newPassword,
            newPassword1: this.changePasswordForm.value.newPassword1,
          }
        }).subscribe(res => {
          if (res.status === 200) {
            this.NzModalRef.close();
            this.emop.message('success', '修改密码成功');
          } else {
            this.emop.notice('error', '修改密码失败', res.message);
          }
        });
      }
    }
  }
}
